import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import './landingPage.css';
import { withRouter } from 'react-router-dom';
import Widget from '../../Shared/Widget';
import LoadingMask from '../../Shared/LoadinngMask/LoadingMask'
import { isMobile } from '../../helpers/utils';

import { LoadingState } from '../../helpers/enum';

class landingPage extends Component {
    componentDidMount() {
        if (this.props.landingPage.bankingAlert.loadingState !== LoadingState.FULFILLED) {
            this.props.bankingAlerts();
            this.props.accountAlerts();
        }

    var root = document.getElementById("root");
   
    var _event = {};

    _event = {
        name: 'END_SETTING_HEIGHT',
        height: root.parentElement.parentElement.offsetHeight
    };

    //Post END Height Event for OLB 
    window.parent.postMessage(_event, '*')
    }

    componentDidUpdate(){
        setTimeout(() => {
        var root = document.getElementById("root");
       
    var _event = {};
    
        _event = {
        name: 'END_SETTING_HEIGHT',
        height: root.parentElement.parentElement.offsetHeight
      };
    
      //Post END Height Event for OLB 
      window.parent.postMessage(_event, '*')
    
      }, 
    0)    
};


    render() {
        const bankingAlert = this.props.landingPage.bankingAlert.items;
        const accountAlert = this.props.landingPage.accountAlert.items.accountAlerts;
        const deliveryAlerts = ["Add / Edit Delivery Methods"];
        const Headings = ["Banking Alerts", "Account Alerts", "Alerts Preferences"];
        const loadingStates = [this.props.landingPage.bankingAlert.loadingState, this.props.landingPage.accountAlert.loadingState, "FULFILLED"];
        const widgets = [bankingAlert, accountAlert, deliveryAlerts];
        const baseRoutes = [`#/bankingAlerts`, `#/accountalerts`, `#/alertPreferences`]
        const propNames = ['name', '', '']
        const { landingPage } = this.props;

        if (landingPage.bankingAlert.loadingState === LoadingState.FAILED || landingPage.accountAlert.loadingState === LoadingState.FAILED) {
            return <div id="error" role="status">
                <h3>We are unable to process your request this time. Please try again later!</h3>
            </div>;
        }

        if (landingPage.bankingAlert.loadingState === LoadingState.PENDING || landingPage.accountAlert.loadingState === LoadingState.PENDING) {
            return <LoadingMask ctrlCss="fullpage" NavigationLink={`Notification Center`} />;
        }
        return (
            <div className={isMobile() ? `mobilecontainer-box` : ``} >
                <Row >
                    {
                        widgets.map((widget, i) => (
                            <Col key={i} className={`${isMobile() ? 'col-mobile' : 'col-lg-4 col-md-4'}`}>
                                <Widget
                                    details={widget}
                                    heading={Headings[i]}
                                    isLoadingOrError={loadingStates[i]}
                                    route={baseRoutes[i]}
                                    propNames={propNames[i]}
                                    subRoute={i === 2 ? ["addOrEditMethodComponent", "manage"] : ""}                                   
                                /> 
                                <div className={!isMobile() ? `input-container-amount` : ``}>
                                        { i === 2 ? <p className="comp-header comp-header-subHeader-desc-prescription italic" role="text">When/if you receive alerts from Regions may depend on factors outside of our control, including your email provider and mobile carrier, and your email, device and app settings.</p> : ``}     
                                </div>                
                            </Col>                            
                        ))                       
                    }
                </Row>              
            </div>
        );
    }
}
export default withRouter(landingPage);